<template>
  <el-col>
    <el-card class="data">
      <div class="flex-space-between w100" slot="header">
        <div class="flex-center">
          <img class="report-img" src="@/assets/images/videos.svg" alt="" />
          <span>OVERVIEW</span>
        </div>
        <div class="videos-buttons">
          <Filters />
          <el-tooltip content="Report" placement="top">
            <el-button
                type="success"
                circle
                icon="el-icon-document"
                @click="generateReport()"
                class="ml10"
            ></el-button>
          </el-tooltip>
        </div>
      </div>
      <div class="d-grid">
        <el-table
          :data="myvideos.data"
          :default-sort="{ prop: order_column, order: order_type }"
          @sort-change="sort"
          class="w100"
          stripe
          v-loading="loading"
        >
          <el-table-column label="Video" prop="title" sortable>
            <template slot-scope="props">
              <a
                :href="`https://youtube.com/watch?v=${props.row.video_id}`"
                target="_blank"
              >
                {{ props.row.title }}
              </a>
            </template>
          </el-table-column>
          <el-table-column
            label="Published"
            prop="published"
            width="auto"
            align="right"
            sortable
          >
            <template slot-scope="props">
              {{ props.row.published | date }}
            </template>
          </el-table-column>
          <el-table-column
            label="Category"
            prop="category"
            width="auto"
            align="right"
            sortable
          ></el-table-column>
          <el-table-column
            label="Subscribers"
            prop="subscribers"
            width="auto"
            align="right"
            sortable
            :formatter="commaNumTable"
          ></el-table-column>
          <el-table-column
            label="Views"
            prop="views"
            width="auto"
            align="right"
            sortable
            :formatter="commaNumTable"
          ></el-table-column>
          <el-table-column
            label="Budget spent"
            prop="budget_spent"
            width="auto"
            align="right"
            sortable
            :formatter="commaNumTable"
          >
            <template v-slot="props">
              <p v-if="props.row.video_approved == 1 && props.row.budget_spent > 0">${{ props.row.budget_spent }}</p>
              <p v-else>Free</p>
            </template>
          </el-table-column>
          <el-table-column
            label="No. Tracks"
            prop="track"
            width="auto"
            align="right"
            sortable
          ></el-table-column>
          <el-table-column label="Actions" align="right" width="80">
            <template slot-scope="props">
              <img
                class="pointer ml10"
                src="@/assets/images/show_track.svg"
                @click="readTracks(props.row)"
                alt=""
              />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="float-right"
          background
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="myvideos.current_page"
          :page-sizes="[5, 10, 25, 50, 100, 500]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="myvideos.total"
        ></el-pagination>
        <el-dialog
          :title="channel_video_chart_name"
          :visible="dialogVisibleVideoCharts"
          width="75%"
          top="7vh"
          @close="closeChartDialog()"
        >
          <div class="flex-end">
            <el-date-picker
              v-model="current_date_range"
              type="daterange"
              unlink-panels
              range-separator="-"
              start-placeholder="Start date"
              end-placeholder="End date"
              :picker-options="dateRangeOptions"
              format="d MMMM yyyy"
              value-format="yyyy-MM-dd"
              @change="setRange()"
            ></el-date-picker>
          </div>
          <el-tabs :tab-position="subTabsPosition">
            <el-col :span="24">
              <el-divider content-position="left">Views</el-divider>
            </el-col>
            <el-col id="vid" :span="24" :lg="12">
              <GChart
                type="LineChart"
                :data="video_chart_views"
                :options="LineChartSett"
                v-if="video_chart_views.length > 1"
              />
              <div v-else class="no-data"><span>No Data</span></div>
            </el-col>
            <el-col id="vid" :span="24" :lg="12">
              <GChart
                type="LineChart"
                :data="video_chart_views_daily"
                :options="LineChartSett"
                v-if="video_chart_views_daily.length > 1"
              />
              <div v-else class="no-data"><span>No Data</span></div>
            </el-col>
            <el-col :span="24">
              <el-divider content-position="left">Subscribers</el-divider>
            </el-col>
            <el-col id="vid" :span="24" :lg="12">
              <GChart
                type="LineChart"
                :data="video_chart_subscribers"
                :options="LineChartSett"
                v-if="video_chart_subscribers.length > 1"
              />
              <div v-else class="no-data"><span>No Data</span></div>
            </el-col>
            <el-col id="vid" :span="24" :lg="12">
              <GChart
                type="LineChart"
                :data="video_chart_subscribers_daily"
                :options="LineChartSett"
                v-if="video_chart_subscribers_daily.length > 1"
              />
              <div v-else class="no-data"><span>No Data</span></div>
            </el-col>
          </el-tabs>
        </el-dialog>
        <el-dialog
          :title="channel_video_name"
          :visible.sync="dialogVisibleVideo"
          width="60%"
          top="7vh"
          class="text-center"
        >
          <iframe width="850" height="550" :src="video_link"></iframe>
        </el-dialog>
        <el-dialog
          title="Tracks"
          :visible.sync="dialogVisibleTracks"
          width="50%"
          top="7vh"
          class="text-center"
        >
          <el-table
            :data="tracks"
            class="w100"
            stripe
            v-loading="tracks_loading"
          >
            <el-table-column prop="track_title" label="Track"></el-table-column>
          </el-table>
        </el-dialog>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { GChart } from 'vue-google-charts'
import Filters from './Filters'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'

export default {
  components: {
    GChart,
    Filters
  },

  data() {
    return {
      channel_video_chart_name: '',
      dialogVisibleVideo: false,
      dialogVisibleTracks: false,
      subTabsPosition: 'top',
      active: 'videos_data',
      video_link: '',
      channel_video_name: '',
      current_date_range: [
        format(subDays(new Date(), 7), 'yyyy-MM-dd'),
        format(addDays(new Date(), 1), 'yyyy-MM-dd')
      ],
      current_video: null
    }
  },

  computed: {
    ...mapState('artistVideos', [
      'loading',
      'tracks_loading',
      'myvideos',
      'date_range',
      'tracks',
      'page_size',
      'order_column',
      'order_type',
      'LineChartSett',
      'dialogVisibleVideoCharts'
    ]),

    ...mapGetters('artistVideos', [
      'video_chart_views',
      'video_chart_views_daily',
      'video_chart_subscribers',
      'video_chart_subscribers_daily'
    ])
  },

  methods: {
    ...mapMutations('artistVideos', [
      'setPage',
      'setPageSize',
      'setOrdering',
      'setDateRange',
      'setChartDialog',
      'setVideoChart',
      'setCsv'
    ]),
    ...mapActions('artistVideos', [
      'readMyVideos',
      'readVideoChart',
      'readVideoTracks'
    ]),

    readVideoChartData(data) {
      this.channel_video_chart_name = `${data.category} - ${data.title}`
      this.current_video = data.video_id
      this.readVideoChart({
        id: data.video_id,
        start: this.date_range[0],
        end: this.date_range[1]
      })
      this.setChartDialog(true)
    },

    playVideo(data) {
      this.dialogVisibleVideo = true
      this.channel_video_name = `${data.title}`
      this.video_link = `https://www.youtube.com/embed/${data.video}`
    },

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readMyVideos()
    },

    currentChange(page) {
      this.setPage(page)
      this.readMyVideos()
    },

    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readMyVideos()
    },

    setRange() {
      this.setDateRange(this.current_date_range)
      this.readVideoChart({
        id: this.current_video,
        start: this.date_range[0],
        end: this.date_range[1]
      })
    },

    closeChartDialog() {
      this.current_video = null
      this.setChartDialog(false)
      this.current_date_range = [
        format(subDays(new Date(), 7), 'yyyy-MM-dd'),
        format(addDays(new Date(), 1), 'yyyy-MM-dd')
      ]
      this.setDateRange(this.current_date_range)
      this.setVideoChart([])
    },

    readTracks(data) {
      this.dialogVisibleTracks = true
      this.readVideoTracks({
        id: data.video_id,
        tracks: true
      })
    },

    generateReport(){
      this.setCsv(1)
      this.readMyVideos()
    }
  },
  created() {
    this.readMyVideos()
  },
  destroyed() {
    this.setPage(1)
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}

h2 {
  color: #3e3e3e;
  font-size: 1.6rem;
  text-align: left;
  font-weight: 100;
  margin: 1.2rem 0.5rem 2rem;
}

span {
  font-weight: 700;
}
.videos-buttons{
  display: flex;
}
</style>
